import { createSelector } from '@ngrx/store';
import * as _ from 'lodash';
import { AnalyticsEntry } from 'app/api/analytics.api.service';
import { selectAnalyticsByAxis } from 'app/main/analytics/selectors/analytics.selectors';
import { PayrollRuleEntry } from 'app/api/payroll.rule.api.service';
import { PayrollEntryByName } from 'app/api/payroll.api.service';

export const selectPayrollAna2Columns = createSelector(
  selectAnalyticsByAxis('ana2'),
  selectAnalyticsByAxis('group'),
  (ana2Entries: AnalyticsEntry[], ana2Group: AnalyticsEntry[]) => {
    const axisByKey = _.groupBy(ana2Group, 'key');
    const filteredColumn = [];
    const filterAxis = ['Axe Paye'];

    _.forEach(ana2Entries, (ana: AnalyticsEntry) => {
      if (ana.groups) {
        _.forEach(ana.groups, (group) => {
          const indexInFilter = filterAxis.indexOf(axisByKey[group][0].name);
          if (axisByKey[group] && indexInFilter > -1) {
            filteredColumn.push(ana);
          }
        });
      }
    });

    return filteredColumn;
  }
);

export const selectPayrollAna2Entries = (
  payrolls: PayrollEntryByName[],
  rules: PayrollRuleEntry[]
) =>
  createSelector(selectPayrollAna2Columns, (ana2) => {
    const ana2Rows = _.map(payrolls, (payroll: PayrollEntryByName) => {
      
      _.forEach(rules, (rule) => {
        if (!payroll.hasOwnProperty('analytics')) {
          payroll.analytics = {};
        }

        if (payroll.matricule === rule.payrollKey) {
          payroll.analytics[rule.payrollExtraKey] = Number(
            rule.payrollExtraValue
          );
        }
      });
      // console.log(payroll);
      return payroll;
    });

    // console.log('Done......;');
    return {
      ana2Columns: ana2,
      ana2Rows,
    };
  });

export const selectPayrollAna2View = (
  payrolls: PayrollEntryByName[],
  rules: PayrollRuleEntry[]
) =>
  createSelector(
    selectPayrollAna2Entries(payrolls, rules),
    ({ ana2Rows, ana2Columns }) => {
      const axisMap: {
        [key: string]: {
          name: string;
          choice: string;
          items: {
            matricule: string;
            percent: number;
            timeline: string;
            value: number;
          }[];
        };
      } = {
        'N/A': {
          name: 'Analytics',
          choice: 'N/A',
          items: [],
        },
      };

      const checkNotAffected: {
        [timeline: string]: { [matricule: string]: number };
      } = {};
      const filteredColumn = _.map(ana2Columns, (ana2Col) => ana2Col.name);
      filteredColumn.push('N/A');

      _.forEach(ana2Rows, (people: PayrollEntryByName) => {
        if (people.analytics) {
          const filterAna2People = {...people.analytics};
          
          Object.keys(filterAna2People).forEach(ana2name => {
            if (filteredColumn.indexOf(ana2name) < 0) {
              delete filterAna2People[ana2name];
            }
          });
          
          const ana2 = Object.keys(filterAna2People);
          // tslint:disable-next-line: variable-name
          const not_affected = 100 - _.sum(Object.values(filterAna2People));
          
          _.forEach(ana2, (key) => {
            if (filteredColumn.indexOf(key) > -1) {
              if (!axisMap.hasOwnProperty(key)) {
                axisMap[key] = { name: 'Analytics', choice: key, items: [] };
              }
              _.forEach(people.items, (item) => {

                if (people.analytics[key] > 0) {
                  axisMap[key].items.push({
                    value: item.fullRawCharges,
                    matricule: people.matricule,
                    percent: people.analytics[key],
                    timeline: item.timeline,
                  });
                }

                if (!checkNotAffected.hasOwnProperty(item.timeline)) {
                  checkNotAffected[item.timeline] = {};
                }

                if (not_affected > 0) {
                  if (!checkNotAffected[item.timeline].hasOwnProperty(people.matricule)) {
                    axisMap['N/A'].items.push({
                      value: item.fullRawCharges,
                      matricule: people.matricule,
                      percent: not_affected,
                      timeline: item.timeline,
                    });
                    checkNotAffected[item.timeline][people.matricule] = item.fullRawCharges;
                  }
                }
              });
            }
          });
        }
      });

      // console.log('axisMap updated.', axisMap);
      const rows = Object.values(axisMap);
      const NArows = rows[0];
      rows.splice(0, 1);
      rows.push(NArows);

      return rows;
    }
  );
